import React from 'react';
import ApplicationLayout from '../../../layouts/ApplicationLayout';
import { connect } from 'react-redux';
import Loader from "../../../components/ui/Loader/Loader";
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import tapIcon from "../../../services/TapIcon";
import Ax from "../../../components/hoc/Ax";
import HttpAPICall from '../../../services/HttpAPICall';
import TapApiUrls, { IAM_API_BASE_URL_2, INVENTORY_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import { DisplayListPagination, DisplaySearchCriteria, PeriodSelectionWithCustom } from '../../../components/TapUi';
import download from '../../../services/DownloadFile';
import swal from "sweetalert";
import { Modal } from 'bootstrap';
import TapSelect from '../../../components/ui/TapSelect';
import AppBaseComponent from '../../../components/AppBaseComponent';
import InputAssetSearch from '../../includes/ui/InputAssetSearch';
import moment from 'moment';
import InputItemSearch from '../../includes/ui/InputItemSearch';
import { Helmet } from 'react-helmet';
import InputEmployeeSearch from '../../includes/ui/InputEmployeeSearch';
import ItemViewInList from '../includes/ItemViewInList';
import ItemDetailsModal from '../../items/itemDetails/ItemDetailsModal';
import POHistoryModal from '../purchaseOrder/POHistoryModal';
import ReqHistoryItemWiseModal from '../requisition/ReqHistoryItemWiseModal';
import PurchaseItemWiseModal from '../purchase/PurchaseItemWiseModal';
import TransferItemWiseListModal from '../inventoryTransfer/TransferItemWiseListModal';
import ConsumptionHistoryModal from '../consumption/ConsumptionHistoryModal';
import ItemTransactionLedger from '../includes/ItemTransactionLedger';
import TapLink from '../../../services/TapLink';
import TapInputNumber from '../../../components/ui/TapInputNumber';
import InputWorkstationSearch from '../../includes/ui/InputWorkstationSearch';
import InputTicketSearch from '../../includes/ui/InputTicketSearch';
import InputProjectSearch from '../../includes/ui/InputProjectSearch';
import TapHelper from '../../../services/TapHelper';
import InputSubAssemblySearch from '../../includes/ui/InputSubAssemblySearch';
import InputCustomerSearch from '../../includes/ui/InputCustomerSearch';
import HistoryDataModal from '../HistoryDataModal';
import WarehouseIndentDocument from './WarehouseIndentDocument';
import DateService from '../../../services/DateService';
import IndentDetailModal from './IndentDetailModal';

class WarehouseIndentList extends AppBaseComponent {

    constructor(props) {
        super(props);
       
        this.initIndentSearchForm       =   {
            search_transaction_id           :   '',
            search_title                    :   '',
            search_warehouse_ids            :   [],
            date_range                      :   null,
            date_range_start                :   null,
            date_range_end                  :   null,
            search_item_ids                 :   [],
            search_item_tags                :   [],
            search_status_ids               :   [],
            search_indent_for               :   '',
            search_asset_ids                :   [],
            search_workstation_ids          :   [],
            search_employee_ids             :   [],
            search_approved_aging           :   '',
            search_voucher_aging            :   '',
            tagged_user_filter              :   '',
            tagged_user_ids                 :   [],
            search_ticket_ids               :   [],
            search_project_ids              :   [],
            search_isc_priorities            :  []
        }

        this.indentSearchFormLabel      =   {
            search_transaction_id           :   'Transaction ID : ',
            search_title                    :   'Title : ',
            search_warehouse_ids            :   'Warehouses : ',
            date_range                      :   'Date Range : ',
            search_item_ids                 :   'Items : ',
            search_item_tags                :   'Item Tags : ',
            search_status_ids               :   'Search Status : ',
            search_indent_for               :   'Indent For : ',
            search_asset_ids                :   'Assets : ',
            search_workstation_ids          :   'Workstation : ',
            search_employee_ids             :   'Employee : ',
            search_approved_aging           :   'Approval Ageing : ',
            search_voucher_aging            :   'Voucher Ageing : ',
            tagged_user_filter              :   'User Tagging : ',
            tagged_user_ids                 :   'Tagged Users : ',
            search_ticket_ids               :   "Tickets : ",
            search_project_ids               :   "Project : ",
            search_isc_priorities             :  "Priorities : "
        }

        this.updateCommentFormInit      =   {
            status                          :   '',
            notes                           :   '',
        }

        this.cancelItemFormInit         =   {
            notes                           :   '',
        }

        this.state                      =   {    
            minimizeTable                   :   false,
            listing_loading                 :   false,
            listing_tbl_page                :   1,
            indent_listing                  :   [],
            listingMeta                     :   null,
            totalListingCount               :   0,
            indentDetail                    :   null,
            indentTransId                   :   [],
            allAllowedStatus                :   [],
            indentId                        :   '',
            addCommentForm                  :   {...this.updateCommentFormInit},
            indentSearchForm                :   {...this.initIndentSearchForm},
            submittedindentSearchForm       :   {...this.initIndentSearchForm},
            formSearchedElems               :   [],
            all_periods                     :   [],
            searchedItems                   :   [],
            allStatusOptions                :   [],
            allItemTags                     :   [],
            searchedAssets                  :   [],
            searchedProjects                :   [],
            searchedEmployees               :   [],
            searchedWorkstations            :   [],
            allWorkstations                 :   [],
            allIndentOptions                :   [],
            all_warehouses                  :   [],
            indentSearchFormDataLoaded      :   false,
            addCommentFormSubmitting        :   false,
            cancelledItemList               :   [],
            cancelItemFormSubmitting        :   false,
            pdfDownloading                  :   false,
            indentAnalysisDownloading       :   false,
            cancelledItemForm               :   {...this.cancelItemFormInit},
            interchangeItemData             :   null,
            interchangeableItemList         :   [],
            interchangeableListingMeta      :   null,
            interchangeableTotalListingCount:   0,
            interchangeable_loading         :   false,
            interchangeable_page            :   1,
            saveInterchangeableItemForm     :   false,
            interchangeItemForm             :   {notes:''},
            searchedCustomers               :  [],
            searchedSubAssemblies            : [],
            userFilters                     :   [
                {value  :   'tagged_me', label : 'My Tagged Warehouse Indent'},
                {value  :   'created_by_me', label : 'Warehouse Indent Created By Me'},
            ],
            allUsers                        :   [],    
            remarkItem                      :   null,     
            remarkSubmitting                :   false,
            searchedTickets                 :   [],  
            criteriaHeight              :            0 ,

        };

        this.myRef                      =   React.createRef();
        this.itemDetailsRef             =   React.createRef();
        this.itemWisePORef              =   React.createRef();
        this.itemWiseReqRef             =   React.createRef();
        this.itemWisePurchaseRef        =   React.createRef();
        this.itemWiseTransferRef        =   React.createRef();
        this.consumptionHistoryRef      =   React.createRef();
        this.transactionLedgerRef       =   React.createRef();
        this.criteriaRef                =   React.createRef();
        this.HistoryRef                 =   React.createRef();
        this.indentDetailRef = React.createRef();
        

        this.searchFormDataUrl              =   INVENTORY_API_BASE_URL_2 + '/warehouse_indent/search_form_data';
        this.warehouseIndentUrl             =   INVENTORY_API_BASE_URL_2 + '/warehouse_indent';
        this.detailUrl                      =   INVENTORY_API_BASE_URL_2 + '/warehouse_indent/detail';
        this.commentUrl                     =   INVENTORY_API_BASE_URL_2 + '/warehouse_indent/comment';
        this.itemUrl                        =   INVENTORY_API_BASE_URL_2 + '/item';    
        this.itemRemarkEditUrl              =   INVENTORY_API_BASE_URL_2 + '/warehouse_indent/item_remark';
        this.projectUrl                     =   IAM_API_BASE_URL_2 + "/project/detail/_replace_id";
        this.warehouseIndentAnalysisUrl     =   INVENTORY_API_BASE_URL_2 + '/report/item-wise-warehouse-indent';
        

    }

    componentDidMount() {
        this.handleSearchParams();
        this.initializeData(this.props)


        this.indentSearchModal = new Modal(document.getElementById('indentSearchModal'), { keyboard: false, backdrop: false });
        this.cancelIndentModal = new Modal(document.getElementById('cancelIndentModal'), { keyboard: false, backdrop: false });
        this.interchangebleItemModal = new Modal(document.getElementById('interchangebleItemModal'), { keyboard: false, backdrop: false });
        this.updateRemarkModal = new Modal(document.getElementById('indentRemarkForm'), { keyboard: false, backdrop: false });
    }

    updateCriteriaHeight = () => {
        if (this.criteriaRef.current) {
            const height = this.criteriaRef.current.offsetHeight;
            if (this.state.criteriaHeight !== height) {
                this.setState({ criteriaHeight: height });
            }
        }
    };
    handleSearchParams = () => {
        const { search } = this.props.location;
        const searchParams = new URLSearchParams(search);
        const searchText = TapHelper.sanitizeObject(searchParams.get('searchText'));

        if (searchText) {
            this.setState(prevState => ({
                indentSearchForm: {
                    ...prevState.indentSearchForm,
                    search_transaction_id: searchText
                }
            }), () => {
                this.submitIndentSearchForm();
            });
        } else {
            let ParamObject = new URLSearchParams(this.props.location.search);
            // this.loadListingTblData(1);
            if (ParamObject.get('search_status_ids') || ParamObject.get('search_voucher_ageing') || ParamObject.get('search_approval_ageing') || ParamObject.get('search_project_ids')) {
                this.initializeData(this.props)
            } else {
                this.loadListingTblData(1);
                this.initializeData(this.props)
            }

            if (this.props.location && this.props.location.state && this.props.location.state.indentId) {
                this.viewIndentDetail(this.props.location.state.indentId)
            }
        }
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.formSearchedElems !== this.state.formSearchedElems) {
            setTimeout(() => {
                this.updateCriteriaHeight();
            }, 1000);
        }
        if (this.props.location.search !== prevProps.location.search) {
            this.handleSearchParams()
        }
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.all_warehouses !== this.props.all_warehouses) {
            this.initializeData(nextProps)
         }     
    }
    
   
    initializeData     =      (pr)      =>      {
        if(pr){
            if(!this.state.indentSearchFormDataLoaded) {
                HttpAPICall.withAthorization('GET', this.searchFormDataUrl, this.props.access_token, null, null, (response) => {
                 let formData = response.data;
                 let all_periods             =       [...this.props.all_periods , {key : 'custom' , display : 'Custom Date Range'}] ;
                    this.setState({
                        indentSearchFormDataLoaded         :       true,
                        //allWorkstations                    :       formData && formData.workstations ?  formData.workstations.map((ws) => {  return {value: ws.id, label:`${ws.workstation_name} `, workstation : ws} }) : [],
                        allIndentOptions                   :       [{value:'asset',label:'Asset'},{value:'workstation',label:'Workstation'},{value:'employee',label:'Employee'},{value:'customer',label:'Customer'},{value:'sub_assembly',label:'Sub Assembly'}],
                        all_warehouses                     :       pr.all_warehouses ? pr.all_warehouses.map((m) => { return { value: m.id, label: `${m.name} (${m.code})` }}) : [] ,
                        all_priorities                     :       formData.priorities ? formData.priorities.map((m) => { return { value: m.key, label: `${m.name} ` }}) : [] ,
                        all_periods                        :       all_periods ,
                        allStatusOptions                   :       formData && formData.status && formData.status.length > 0 ?  formData.status.map((s) => { return {value: s.id, label: s.name}; }) : [],
                        allItemTags                        :       formData && formData.tags && formData.tags.length > 0 ? formData.tags.map((s) => { return {value: s.id, label: s.name}; }) : [],
                        allUsers                     :   formData && formData.users ? formData.users.map((s) => { return {value: s.id, label: s.full_name,site_ids:s.linked_sites}; }) : [],
                    });
                });
                let ParamObject                 =       new URLSearchParams(pr.location.search);
                if(ParamObject.get('search_voucher_ageing') || ParamObject.get('search_approval_ageing') ){
                    let status_ids           =         ParamObject.get('search_status_ids').split(',').map(Number);
                    let updateFilterForm        =   {
                        search_voucher_aging : ParamObject.get('search_voucher_ageing') ?  ParamObject.get('search_voucher_ageing') : '',
                        search_approved_aging : ParamObject.get('search_approval_ageing') ?  ParamObject.get('search_approval_ageing') : '',
                        search_status_ids: status_ids
                    };
                    if (ParamObject.get('search_warehouse_ids')) {
                        let warehouse        =  pr.all_warehouses.find(us => us.id == ParamObject.get('search_warehouse_ids'));
                        if (warehouse) {
                            updateFilterForm['search_warehouse_ids'] = [warehouse.id];
                        }
                    }
                    if (ParamObject.get('tagged_user')) {
                        updateFilterForm['tagged_user_filter'] = ParamObject.get('tagged_user');
                    }
    

                   
                    setTimeout(() => {
                        this.setState({
                            indentSearchForm  : { ...this.state.indentSearchForm, ...updateFilterForm},                      
                        },
                            function () {
                                this.submitIndentSearchForm();
                            });
                    }, 1000)
                }else if (ParamObject.get('search_status_ids')){
                    let status_ids           =         ParamObject.get('search_status_ids').split(',').map(Number);
                    let updateFilterForm     =          { search_status_ids: status_ids }
                    if (ParamObject.get('search_warehouse_ids')) {
                        let warehouse        =  pr.all_warehouses.find(us => us.id == ParamObject.get('search_warehouse_ids'));
                        if (warehouse) {
                            updateFilterForm['search_warehouse_ids'] = [warehouse.id];
                        }
                    }
                    if (ParamObject.get('tagged_user')) {
                        updateFilterForm['tagged_user_filter'] = ParamObject.get('tagged_user');
                    }
    
                   
                    setTimeout(() => {
                        this.setState({
                            indentSearchForm  : { ...this.state.indentSearchForm, ...updateFilterForm},                      
                        },
                            function () {
                                this.submitIndentSearchForm();
                            });
                    }, 1000)
                }

                if(ParamObject.get('search_project_id')) {
                    this.getProjectDetail(ParamObject.get('search_project_id'))
                }

            }
        
        }
    }

    getProjectDetail = (id) => {
        HttpAPICall.withAthorization("GET", this.projectUrl.replace('_replace_id', id), this.props.access_token, null, null, (resp) => {
            const projectDetail   =   resp.data.data
            if(projectDetail) {
                this.setState({
                    searchedProjects : [
                        {
                            label: `${projectDetail.name} (${projectDetail.transaction_id})`,
                            display_label: `${projectDetail.name} (${projectDetail.transaction_id})`,
                            value: projectDetail.id
                        }
                    ],
                    indentSearchForm : {...this.state.indentSearchForm, search_project_ids : [projectDetail.id]}
                }, () => {
                    this.submitIndentSearchForm();
                })
            }

        })
    }


   
  
     //************************GET Warehouse Indent LISTING**************** */
     loadListingTblData                 =   (page = 1)  =>         {
        this.setState({listing_loading: true, listing_tbl_page: page});
        let params                      =   {page:page,...this.state.submittedindentSearchForm};
        HttpAPICall.withAthorization('GET',  this.warehouseIndentUrl, this.props.access_token, params, {}, (resp) => {
            let respData            =       resp.data;
            this.setState({
                indent_listing      :       respData.data,
                listingMeta         :       respData.meta,
                totalListingCount   :       respData.meta.total,
        });
        }).then(() => this.setState({listing_loading: false}));
    }

    indentSearchModalInit               =       ()             =>        {
        this.indentSearchModal.show();
    }
    
    submitIndentSearchForm                =       (e)          =>          {
        e && e.preventDefault()
        let serachFormKeys              =   Object.keys(this.state.indentSearchForm);
       
        let searchedElems               =   [];
        let searchParams                =   {};
        serachFormKeys.map((key)        =>  {
            
            let label                       =   this.indentSearchFormLabel[key];
            let value                       =   this.state.indentSearchForm[key];
            
            if(value && value.toString().length > 0) {
                searchParams[key]      =   value;
           if(label) {
                let show_val            =   value;
                if(key == 'search_transaction_id') {
                    show_val            =   this.state.indentSearchForm && this.state.indentSearchForm.search_transaction_id ? this.state.indentSearchForm.search_transaction_id : '';
                }
                if(key == 'search_title') {
                    show_val            =   this.state.indentSearchForm && this.state.indentSearchForm.search_title ? this.state.indentSearchForm.search_title  : '';
                }
                if(key == 'search_warehouse_ids') {
                    show_val            =   this.state.all_warehouses.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                }
                if(key == 'search_isc_priorities') {
                    show_val            =   this.state.all_priorities.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                }
                if(key == 'search_item_ids') {
                    show_val            =   this.state.searchedItems ? this.state.searchedItems.map(s => s.display_label).join(', ') : '';
                }
                if(key === 'search_ticket_ids') {
                    show_val        =   this.state.searchedTickets ? this.state.searchedTickets.map(s => s.value).join(', ') : '';
                }
                if(key == 'search_project_ids') {
                      show_val            =   this.state.searchedProjects ? this.state.searchedProjects.map(s => s.display_label).join(', ') : '';
                    // show_val        =  this.state.indentSearchForm && this.state.indentSearchForm.search_project_id ? this.state.indentSearchForm.search_project_id : '';
                }
                if(key == 'search_item_tags') {
                    show_val            =   this.state.allItemTags.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                }
                if(key == 'search_status_ids') {
                    show_val            =   this.state.allStatusOptions.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                }
                
                if(key == 'search_asset_ids') {
                    show_val            =   this.state.searchedAssets ? this.state.searchedAssets.map(s => s.display_label).join(', ') : '';
                }
                if(key == 'search_workstation_ids') {
                    show_val            =   this.state.searchedWorkstations ? this.state.searchedWorkstations.map(s => s.label).join(', ') : '';
                }
                if(key == 'search_employee_ids') {
                    show_val            =   this.state.searchedEmployees ? this.state.searchedEmployees.map(s => s.label).join(', ') : '';
                }
                if(key == 'search_customer_ids') {
                    show_val            =   this.state.searchedCustomers ? this.state.searchedCustomers.map(s => s.label).join(', ') : '';
                }
                if(key == 'search_sub_assembly_ids') {
                    show_val            =   this.state.searchedSubAssemblies ? this.state.searchedSubAssemblies.map(s => s.label).join(', ') : '';
                }
                if(key == 'search_approved_aging') {
                    show_val            =   this.state.indentSearchForm && this.state.indentSearchForm.search_approved_aging ? this.state.indentSearchForm.search_approved_aging  : '';
                }
                if(key == 'search_voucher_aging') {
                    show_val            =   this.state.indentSearchForm && this.state.indentSearchForm.search_voucher_aging ? this.state.indentSearchForm.search_voucher_aging  : '';
                }
                if(key == 'tagged_user_filter') {
                    show_val            =   this.state.userFilters.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                }
                if(key == 'tagged_user_ids') {
                    show_val            =   this.state.allUsers.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                }
                if(key == 'date_range') {
                    let  start_range         =      moment(this.state.indentSearchForm.date_range_start).format('DD-MMM-YYYY');
                    let end_range            =      moment(this.state.indentSearchForm.date_range_end).format('DD-MMM-YYYY')
                    let display_custom      =      `Custom Date Range (${start_range} - ${end_range})`
                    show_val                 =     this.state.all_periods.filter((s) => value.includes(s.key)).map(s => s.display_with_date ? s.display_with_date : display_custom);
                }
                searchedElems.push(label + `<b>${show_val}</b>`);
            }
        }
    });
        this.setState({
            submittedindentSearchForm   :   {...this.state.indentSearchForm},
            formSearchedElems           :   searchedElems
        }, () => {
            this.indentSearchModal.hide()
            this.loadListingTblData(1);
        });
    }

    indentSearchClear                  =        ()             =>        {
        this.setState({
            formSearchedElems             :   [],
            indentSearchForm              :   {...this.initIndentSearchForm},
            submittedindentSearchForm     :   {...this.initIndentSearchForm},
            searchedAssets                :   [],
            searchedEmployees             :   [],
            searchedProjects              :   []
        }, () => {
            this.loadListingTblData(1);
             this.setState({
                criteriaHeight: 0
            })
            this.indentSearchModal.hide();
        });
    }

    openAddStoreIndentScreen        =       ()      =>      {
        this.props.history.push('/warehouse_indent_add')
    }

   

    closeViewDetails        =       ()      =>      {
        this.setState({minimizeTable : false})
    }

    viewIndentDetail = (transaction_id) => {
        
        this.setState({
            minimizeTable: true,
            indentTransId: transaction_id
        });
        if (this.indentDetailRef.current) {
            this.indentDetailRef.current.getIndentDetail(transaction_id);
        }
    }


    viewItemModalInit                    =   (item)  =>  { 
        if(item){
            this.itemDetailsRef.current.modalInit(item)
        }
    }
   
    updateComment = () => {
    if (this.indentDetailRef.current) {
        this.indentDetailRef.current.scrollToComment();
    }
}

    getIndentDetail        =       (transaction_id)      =>      {
    
        this.setState({indent_loading : true})
        HttpAPICall.withAthorization('GET',  this.detailUrl + '/' + transaction_id, this.props.access_token, null, {}, (resp) => {
            let respData = resp.data;
            this.setState({
                indentDetail    :   respData.data,
                indentTransId   :   respData.data.transaction_id,
                allAllowedStatus     :   respData.data && respData.data.user_status && respData.data.user_status.length > 0 ? respData.data.user_status.map((s) => { return {value: s.id, label: s.name}; }) : [] ,
                indentId        :   respData.data.id,
                addCommentForm       :  {...this.updateCommentFormInit , status : respData.data.status_data ? respData.data.status_data.id : '' }   
            });
        
        },(err) => {
            if(err){
                this.setState({minimizeTable : false})
            }
        }).then(() => this.setState({indent_loading : false}));
   
    }

    //***************************CLONE Indent ******************** */
    cloneIndent = () => {

        if (this.state.indentDetail) {
            this.props.history.push({ pathname: `/warehouse_indent_add`, state: { indentDetailData: this.state.indentDetail, clone: 'yes' } })

        }

    }
    /***************Open Indent from Voucher**************** */

    checkAllItem() {
        let indentItemForCheckbox      =   document.getElementsByClassName('indent_item_id_checkbox')
        if(indentItemForCheckbox && indentItemForCheckbox.length > 0) {
            for (let i = 0; i < indentItemForCheckbox.length; i++) {
                indentItemForCheckbox[i].checked = document.getElementById('all_check_indent').checked;
            }
        }
    }

    openIndentFulfillmentfromVoucher = () => {
        if (this.indentDetailRef.current) {
            this.indentDetailRef.current.openIndentFulfillmentfromVoucher();
        }
    }

    transferPurchaseInit = () => {
        if (this.indentDetailRef.current) {
            this.indentDetailRef.current.transferPurchaseInit();
        }
    }

    /***************Open Indent from Listing**************** */

    checkAllIndentItemList() {
        let indentItemForCheckbox      =   document.getElementsByClassName('indent_list_id_checkbox')
        if(indentItemForCheckbox && indentItemForCheckbox.length > 0) {
            for (let i = 0; i < indentItemForCheckbox.length; i++) {
                indentItemForCheckbox[i].checked = document.getElementById('all_indent_list_check').checked;
            }
        }
    }

    openIndentFulfillment        =       ()          =>      {
        let indent_transacton_ids           =   [];
        let warehouse_ids                   =   [];
       
        let indentItemForCheckbox      =   document.getElementsByClassName('indent_list_id_checkbox');
        if(indentItemForCheckbox && indentItemForCheckbox.length > 0) {
            for (let i = 0; i < indentItemForCheckbox.length; i++) {
                if(indentItemForCheckbox[i].checked) {
                    indent_transacton_ids.push(indentItemForCheckbox[i].value);
                    warehouse_ids.push(indentItemForCheckbox[i].getAttribute("data-warehouseId"));
                  
                }
            }
        }
        let warehouse_ids_unique            =   warehouse_ids.filter((item, i, ar) => ar.indexOf(item) === i);
        if(warehouse_ids_unique.length > 1) {
            toast.error('Please select item with same warehouse', { position: toast.POSITION.TOP_RIGHT });
        }else {
       
            let warehouseIndentData                    =   {   
                warehouse_id                :   warehouse_ids[0],
                transactionId              :   indent_transacton_ids.toString()
            };
           
            if(warehouseIndentData && warehouseIndentData.warehouse_id){
                this.props.history.push({ pathname: `/indent_fulfillment`, state: { warehouseIndentData : warehouseIndentData} });
            }else{
                this.props.history.push({ pathname: `/indent_fulfillment` });
            }
            
        }
           
    }

    cancelWarehouseIndentItem = () => {
        if (this.indentDetailRef.current) {
            this.indentDetailRef.current.cancelWarehouseIndentItem();
        }
    }
    editIndent = () => {
        if (this.indentDetailRef.current) {
            this.indentDetailRef.current.editIndent();
        }
    }

    cloneIndent = () => {
        if (this.indentDetailRef.current) {
            this.indentDetailRef.current.cloneIndent();
        }
    }

    deleteIndent = (transaction_id) => {
        if (this.indentDetailRef.current) {
            this.indentDetailRef.current.deleteIndent(transaction_id);
        }
    }
    viewItemWisePOInit          =       (itemData=null,warehouse_id='',indent_transacton_id='') => {
        //if (this.props.permissions.includes('isc-po-view')) {
            this.itemWisePORef.current.modalInit(itemData, '', indent_transacton_id)
        //}
    }

    viewItemWiseReqInit          =       (itemData=null,warehouse_id='',indent_transacton_id='') => {
        this.itemWiseReqRef.current.modalInit(itemData,'',indent_transacton_id)
    }

    viewItemWisePurchaseInit          =       (itemData=null,warehouse_id='',indent_transacton_id='') => {
        this.itemWisePurchaseRef.current.modalInit(itemData,'',indent_transacton_id)
    }

    viewItemWiseTransferInit          =       (itemData=null,warehouse_id='',indent_transacton_id='') => {
        this.itemWiseTransferRef.current.modalInit(itemData,'',indent_transacton_id)
    }

    viewConsumptionModalInit                       =   (data,k)  =>  {
        if (data) {
            this.consumptionHistoryRef.current.modalInit(data, null, null)
        }
         
    }
    viewHistoryModalInit = (data, defaultAction = 'pr_history', extraParams = {}) => {

        if (this.state.indentDetail && data) {
            console.log(this.state.indentDetail,data );
            
            let indentDetail = this.state.indentDetail;
            this.HistoryRef.current.modalHistoryInit(data, {
                warehouse_id: indentDetail?.warehouse_id,
                warehouse_detail: indentDetail?.warehouse_detail,
                indent_transaction_id: indentDetail.transaction_id || '',
                defaultAction: defaultAction,
                historyTypes: [
                    { value: 'pr_history', label: 'PR History' },
                    { value: 'consumption', label: 'Consumption History' },
                    { value: 'transaction_ledger', label: 'Item Transaction Ledger' }
                ]
            });
        }
    }

   
      viewTransactionLedgerModalInit               =   (data,k)  =>  {
        if (this.state.indentDetail) {

            let indentData = this.state.indentDetail;
            if (data) {
                this.transactionLedgerRef.current.modalInit(data, indentData.warehouse_id,indentData.warehouse_detail)
            }
        }
         
      }

    downloadPdfHandler = (transaction_id) => {
    if (this.indentDetailRef.current) {
        this.indentDetailRef.current.downloadPdfHandler(transaction_id);
    }
}

downloadIndentAnalysisReportHandler = (transaction_id) => {
    if (this.indentDetailRef.current) {
        this.indentDetailRef.current.downloadIndentAnalysisReportHandler(transaction_id);
    }
}
    

    viewInterchangeableModalInit        =       (itemdata=null,key)   =>      {
        
        this.interchangebleItemModal.show();
        this.setState({
            interchangeItemData     :   itemdata ,
            interchangeItemForm     :    {notes:''}   
        },() => this.getInterChangeableItemList(itemdata?.itemData?.id,1))
    }
    
    getInterChangeableItemList      =       (id,page=1)      =>      {
        this.setState({ interchangeable_loading: true, interchangeable_page: page,interchangeableItemList:[] });
        HttpAPICall.withAthorization('GET', this.itemUrl + '/interchangeable_item/' + id, this.props.access_token, {}, {}, (resp) => {
            let respData = resp.data;
            this.setState({
                interchangeableItemList                :    respData.data,
                interchangeableListingMeta             :   respData.meta,
                interchangeableTotalListingCount       :   respData.meta.total,
               
            })
        }).then(() => this.setState({ interchangeable_loading : false }))
    }
    
    checkAllInterchangeList                          =   ()  =>  {
        let interchangeItemCheckboxCollections      =   document.getElementsByClassName('interchange_id_checkbox');
        if(interchangeItemCheckboxCollections && interchangeItemCheckboxCollections.length > 0) {
            for (let i = 0; i < interchangeItemCheckboxCollections.length; i++) {
                interchangeItemCheckboxCollections[i].checked = document.getElementById('all_check_interchange').checked;
            }
        }
    }

    submitSelectedInterchangeItem        =       (e)         =>      {
        e.preventDefault();
         
        let  interchangeItemCheckboxCollections      =    document.getElementsByClassName('interchange_id_checkbox');
        let allSelectedItems                =    [];
        let data                            =   this.state.interchangeItemData ? this.state.interchangeItemData : null;
        let totalQty = 0
        
        if( interchangeItemCheckboxCollections &&  interchangeItemCheckboxCollections.length > 0) {
            for (let i = 0; i <  interchangeItemCheckboxCollections.length; i++) {
               
                if( interchangeItemCheckboxCollections[i].checked) {
                    // interchangeItemCheckboxCollections[i].disabled = true;
                    let item_id    =       interchangeItemCheckboxCollections[i].value;
                    let qty        =    interchangeItemCheckboxCollections[i].getAttribute("data-qty");
                    allSelectedItems.push({item_id: item_id,qty:qty})
                    totalQty += parseFloat(qty);
                }
            }
        }

   
       //***************************HANDLE SELECTED ITEM FROM PO  **********************/
        if (allSelectedItems.length == 0) {
            toast.error('Please select atleast one Item', { position: toast.POSITION.TOP_RIGHT })
        }else if(allSelectedItems.find(i => parseFloat(i.qty) <= 0)) {
            toast.error('Every Item\'s qty must be more than 0.', { position: toast.POSITION.TOP_RIGHT })
           
        }else if(allSelectedItems.find(i => i.qty == '' || i.qty == null)) {
            toast.error('Every Item\'s  qty should not be blank', { position: toast.POSITION.TOP_RIGHT })
           
        }else if(totalQty > data.pending_qty){
            toast.error('Total Qty cannot be more than pending Qty', { position: toast.POSITION.TOP_RIGHT })
        }else{
            let frmData = {
                transaction_id       :      data.transaction_id,
                item_id              :      data.itemData.id,
                replace_items          : allSelectedItems,
                ...this.state.interchangeItemForm
            }
            this.setState({ saveInterchangeableItemForm: true })
            HttpAPICall.withAthorization('PUT', this.warehouseIndentUrl + '/item_change', this.props.access_token, {}, { ...frmData }, (response) => {
                toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
                this.interchangebleItemModal.hide();
                this.getIndentDetail(data.transaction_id)
            }).then(() => this.setState({ saveInterchangeableItemForm: false }));
            
        }
    }

    storeIndentJsx            =       ()      =>    {
        let deleteVoucher = false;
        if(this.state.indentDetail && this.state.indentDetail.items && this.state.indentDetail.items.length > 0){
            const allItemsMatch = this.state.indentDetail.items.every(item => item.indent_qty == item.pending_qty);
            if(this.state.indentDetail.status_data.level == 3 && !allItemsMatch){
                deleteVoucher = true
            }
        }
        return (<Ax><div className="page_title row m0">
            <div className={this.state.minimizeTable ? "col-3" : "col-12"}>
                <h3>Warehouse Indent</h3>
                <div className="text-end mt15">
                    {(!this.state.minimizeTable) ?
                        <Ax>
                            <button type="button" className="btn btn-primary" disabled={!this.props.permissions.includes('isc-warehouse-indent-add')} onClick={this.openAddStoreIndentScreen}>New Warehouse Indent</button>
                            <button type="button" className="btn btn-secondary" onClick={this.openIndentFulfillment}>Indent Fulfillment</button>
                            <button type="button" className="btn btn-secondary" onClick={this.indentSearchModalInit} disabled={this.state.listing_loading} >
                                <tapIcon.imageIcon icon={tapIcon.SearchIcon} className="img-fluid" alt="item-action" />
                            </button>
                        </Ax>
                        : null}


                </div>
            </div>
            {
                this.state.minimizeTable
                    ? (
                        <div className="col-9 tap_border_left">
                            <h3>Warehouse Indent : {this.state.indentTransId} </h3>
                            <div className="text-end mt15">
                                <button type="button" className="btn btn-secondary" onClick={this.openIndentFulfillmentfromVoucher} disabled={this.state?.indentDetail?.is_closed == 'Y' ? true : false}>Indent Fulfillment</button>
                                <button type="button" className="btn btn-secondary" disabled={!this.props.permissions.includes('isc-warehouse-indent-status_change')} onClick={() => this.updateComment()}>Update Status </button>
                                <button type="button" className="btn btn-secondary" id='actionMenuButton' data-bs-toggle="dropdown" ><tapIcon.FontAwesomeIcon icon={tapIcon.faDownload} /></button>
                                <ul className="dropdown-menu cursor_pointer" aria-labelledby="dropdownMenuButton1">
                                    <li><a className="dropdown-item" onClick={() => this.downloadPdfHandler(this.state.indentTransId)} disabled={this.state.pdfDownloading}>Pdf Download</a></li>
                                    <li><a className="dropdown-item" onClick={() => this.downloadIndentAnalysisReportHandler(this.state.indentTransId)} disabled={this.state.indentAnalysisDownloading}>Indent Analysis Report</a></li>
                                </ul>
                                <button type="button" id='actionMenuButton' data-bs-toggle="dropdown" aria-expanded="false" className="btn btn-secondary">
                                    <tapIcon.imageIcon icon={tapIcon.ActionIcon} className="img-fluid" alt="item-action" />
                                </button>
                                <ul className="dropdown-menu cursor_pointer" aria-labelledby="dropdownMenuButton1">
                                    <li>
                                        <TapLink
                                            pathname={'/warehouse_indent_add'}
                                            state={{ indentDetailData: this.state.indentDetail }}
                                            conditions={{
                                                canEdit: this.state.indentDetail?.can_edit === 'Y' &&
                                                    this.props.permissions.includes('isc-warehouse-indent-edit') ? 'Y' : 'N',
                                                canShowTitle: this.state.indentDetail?.can_edit == 'N' ||
                                                    !this.props.permissions.includes('isc-warehouse-indent-edit') ? 'Y' : 'N',
                                            }}
                                        >
                                            Edit
                                        </TapLink>
                                    </li>

                                    <li>
                                        <Link role="button"
                                            onClick={() => {
                                                if (this.state?.indentDetail?.is_closed == 'N' && this.props.permissions.includes('isc-warehouse-indent-cancel_item')) {
                                                    return this.cancelWarehouseIndentItem()
                                                }
                                            }}
                                            className={['dropdown-item cursor_pointer', this.state?.indentDetail?.is_closed == 'N' && this.props.permissions.includes('isc-warehouse-indent-cancel_item') ? '' : 'disabled'].join(' ')}
                                            title={this.state?.indentDetail?.is_closed == 'Y' || !this.props.permissions.includes('isc-warehouse-indent-cancel_item') ? 'You do not have permission to perform this action' : ''}
                                            style={{ "pointerEvents": "all" }}
                                        >Cancel Item</Link>
                                    </li>
                                    <li><a className={(this.state.listing_loading == true ? "dropdown-item disabled" : "dropdown-item")} onClick={() => this.cloneIndent()} disabled={this.state.pdfDownloading == true}>Clone</a></li>
                                    <li><a className={this.state?.indentDetail?.can_delete == "N" || deleteVoucher || !this.props.permissions.includes('isc-warehouse-indent-delete') ? "dropdown-item disabled" : "dropdown-item"} onClick={() => this.deleteIndent(this.state.indentTransId)} disabled={this.state.indentDetail?.can_delete == "TT"}>Delete</a></li>
                                    <li><a className={this.state?.indentDetail?.is_closed == 'Y' || !this.props.permissions.includes('isc-inventory_transfer-add') ? "dropdown-item disabled" : "dropdown-item"} onClick={() => this.transferPurchaseInit()} >Transfer Purchase</a></li>

                                </ul>
                                <button type="button" className="btn btn-secondary" onClick={this.closeViewDetails}>
                                    <tapIcon.imageIcon icon={tapIcon.CloseIcon} className="img-fluid" alt="item-close" />
                                </button>

                            </div>
                        </div>
                    )
                    : null
            }
        </div>
            <div className="container-fluid pl5">
                <div className="page_containt row">
                    <div className={['pageTbl', this.state.minimizeTable ? 'col-3' : 'col-12'].join(' ')} >{this.storeIndentLisitngJsx()}</div>
                    {this.state.minimizeTable ? <div className="col-9 pr4 pl4"><div className="bg-white p-2" style={{ height: "100%" }}>{this.indentViewDetailJsx()}</div></div> : null}
                </div>
            </div>
        </Ax>);
    }

    storeIndentLisitngJsx            =   ()   =>   {
        return(<Ax>
             <div ref={this.criteriaRef}
                style={{
                    position: 'sticky',
                    top: 0,
                    background: 'white',
                }}>
         <DisplaySearchCriteria searchedElems={this.state.formSearchedElems} onClearFilter={this.indentSearchClear} /> 
         </div>
            <table className="table table-bordered  bg-white table-sm">
                <thead className="table-secondary"style={{top: `${this.state.criteriaHeight}px`,
                    position: 'sticky',
                }}  >
                    {this.state.minimizeTable
                        ? (<tr>
                            <th scope="col" style={{ width: "15%" }}>Warehouse Indent</th>
                        </tr>)
                        : (<tr className='text-center'>
                            <th scope="col" style={{ width: "5%" }}><input type="checkbox"  onChange={this.checkAllIndentItemList} disabled={true} id="all_indent_list_check"/></th>
                            <th scope="col" style={{ width: "10%" }}>Transaction ID</th>
                            <th scope="col" style={{ width: "10%" }}>Date of Transaction</th>
                            <th scope="col" style={{ width: "15%" }}>Warehouse</th>
                            <th scope="col" style={{ width: "18%" }}>Indent For</th>
                            <th scope="col" style={{ width: "15%" }}>Title</th>
                            <th scope="col" style={{ width: "8%" }}>Status</th>
                            <th scope="col" className="text-center" style={{ width: "6%" }}>Indent Qty</th>
                            <th scope="col" className="text-end" style={{ width: "6%" }}>Fullfilled Qty</th>
                            <th scope="col" className="text-center" style={{ width: "5%" }}>Action</th>
                        </tr>)
                    }
                </thead>
                <tbody>
                    {this.state.listing_loading
                        ? (<tr><td colSpan="10"><Loader /></td></tr>)
                        : (this.state.indent_listing.length > 0
                            ? (this.state.indent_listing.map((item, index) => {
                                return (<tr key={index} >
                                    {
                                        this.state.minimizeTable
                                            ? (
                                                <Ax>
                                                    <td>
                                                        <a role="button" onClick={() => this.viewIndentDetail(item.transaction_id)} className="link-primary">{item.transaction_id}</a>
                                                        <br /><small>{item.transaction_date_display}</small>
                                                        <small style={{ float: 'right' }}>{item.status_data ? item.status_data.name : ''}</small>
                                                    </td>
                                                </Ax>
                                            )
                                            : (<Ax>
                                                <td className="text-center">
                                                    <input type="checkbox"
                                                    name="indent"
                                                    value={item.transaction_id}
                                                    className="indent_list_id_checkbox"
                                                    data-warehouseId={item.warehouse_id}
                                            
                                                    disabled={item.status_data && item.status_data.level !== 3 && item.status_data.level !== 4 }
                                                     /> 
                                                    </td>
                                                <td className="text-center"><a role="button" onClick={() => this.viewIndentDetail(item.transaction_id)} className="link-primary">{item.transaction_id}</a></td>
                                                <td className="text-center">{item.transaction_date_display}</td>
                                                <td>{item.warehouse ? item.warehouse.name : '-'}</td>
                                                <td>
                                                    {item.assetProfile ? <div><small className='form-text'>{item.indent_for == 'asset' ? 'Asset : ' : ''}</small> {item.assetProfile.name} </div>
                                                    : item.workstation ? <div><small className='form-text'>{item.indent_for == 'workstation' ?  'Workstation : ' : ''}</small> {item.workstation.workstation_name}  </div> 
                                                    : item.employee ? <div><small className='form-text'>{item.indent_for == 'employee' ?  'Employee : ' : ''}</small> {item.employee.name}  </div> 
                                                    : item.subAssembly ? <div><small className='form-text'>{item.indent_for == 'sub_assembly' ?  'Sub Assembly : ' : ''}</small> {item.subAssembly.name}  </div> 
                                                    : item.customer ? <div><small className='form-text'>{item.indent_for == 'customer' ?  'Customer : ' : ''}</small> {item.customer.name}  </div> 
                                                    : ''  } 
                                                </td>
                                                <td>{item.title ?? "-"} </td>
                                                <td className="text-center">{item.status_data ? item.status_data.name : '-'}</td>
                                                <td className="text-end">{item.total_qty}</td>
                                                <td className="text-end">{item.fullfilled_qty ? item.fullfilled_qty : 0}</td>
                                                <td className="text-center">
                                                    <button type="button" id='actionMenuButton' data-bs-toggle="dropdown" aria-expanded="false" className="btn">
                                                        <tapIcon.FontAwesomeIcon icon={tapIcon.faEllipsisV} />
                                                    </button>
                                                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                        <li><a className="dropdown-item" role="button" onClick={() => this.viewIndentDetail(item.transaction_id)}>View</a></li>
                                                    </ul>
                                                </td>
                                            </Ax>
                                            )}
                                </tr>)
                            }))
                            : (<tr><td colSpan="10" className="text-center">No Records</td></tr>)
                        )
                    }

                </tbody>
            </table>
            <DisplayListPagination
                meta={this.state.listingMeta}
                onPageChange={(e) => this.loadListingTblData(e.selected + 1)}
            />
        </Ax>)
    }


   indentViewDetailJsx = () => {
    return (
        <div className="tab_content_header">
            <IndentDetailModal
                ref={this.indentDetailRef}
                renderAs="inline"
                transaction_id={this.state.indentTransId}
                history={this.props.history}
                onDetailLoaded={(data) => {
                    this.setState({ indentDetail: data, indent_loading: false });
                }}
                onUpdate={() => {
                    this.loadListingTblData(this.state.listing_tbl_page);
                }}
                onDelete={() => {
                    this.setState({ minimizeTable: false });
                    this.loadListingTblData(1);
                }}
            />
        </div>
    );
}

    indentSearchModalJsx               =        ()             =>        {
       
        return (
            <div className="modal fade" id="indentSearchModal" tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="searchAssetModalLabel">Indent Search</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={this.indentClear}></button>
                        </div>
                        <form id="indentSearchForm" onSubmit={this.submitIndentSearchForm}>
                            <div className="modal-body">
                                {!this.state.indentSearchFormDataLoaded ? <Loader />
                                    : <Ax>
                                        <div className="row my-3 align-items-center">
                                            <label className="col-sm-2 col-form-label col-form-label-sm  ">Transaction ID</label>
                                            <div className="col-sm-4">
                                                <input
                                                    name="search_transaction_id"
                                                    type="text"
                                                    value={this.state.indentSearchForm.search_transaction_id}
                                                    className="form-control"
                                                    autoComplete="off"
                                                    onChange={(e) => this.formInputHandler(e, "indentSearchForm")}
                                                    placeholder="Please enter Transaction ID"
                                                    style={{ height: "30px", fontSize: "93%" }}
                                                />
                                            </div>
                                            <label className="col-sm-1 col-form-label col-form-label-sm  ">Title</label>
                                            <div className="col-sm-5">
                                                <input
                                                    name="search_title"
                                                    type="text"
                                                    value={this.state.indentSearchForm.search_title}
                                                    className="form-control"
                                                    autoComplete="off"
                                                    onChange={(e) => this.formInputHandler(e, "indentSearchForm")}
                                                    placeholder="Please enter Title"
                                                    style={{ height: "30px", fontSize: "93%" }}
                                                />
                                            </div>


                                        </div>

                                        <div className="row my-3 align-items-center">
                                            <label className="col-sm-2 col-form-label col-form-label-sm  ">Status</label>
                                            <div className="col-sm-10">
                                                <TapSelect
                                                    options={this.state.allStatusOptions}
                                                    changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'indentSearchForm', 'search_status_ids')}
                                                    isSearchable={true}
                                                    isClearable={true}
                                                    isMulti={true}

                                                    value={this.state.allStatusOptions.filter(s => this.state.indentSearchForm.search_status_ids.includes(s.value))}
                                                    placeholder="Select Status"
                                                    containerHeight="30px"
                                                    fontSize="93%"
                                                />
                                            </div>
                                        </div>

                                        <div className="row my-3 align-items-center">
                                            <label className="col-sm-2 col-form-label col-form-label-sm  ">Warehouse</label>
                                            <div className="col-sm-10">
                                                <TapSelect
                                                    options={this.state.all_warehouses}
                                                    changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'indentSearchForm', 'search_warehouse_ids')}
                                                    value={this.state.all_warehouses.filter(u => this.state.indentSearchForm?.search_warehouse_ids?.includes(u.value))}
                                                    isSearchable={true}
                                                    isMulti={true}
                                                    isClearable={true}
                                                    placeholder="Select Warehouses"
                                                    containerHeight="30px"
                                                    fontSize="93%"
                                                />
                                            </div>
                                        </div>
                                        <div className="row my-3 align-items-center">
                                            <label className="col-sm-2 col-form-label col-form-label-sm  ">Priorites</label>
                                            <div className="col-sm-10">
                                                <TapSelect
                                                    options={this.state.all_priorities}
                                                    changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'indentSearchForm', 'search_isc_priorities')}
                                                    isSearchable={true}
                                                    isClearable={true}
                                                    isMulti={true}

                                                    value={this.state.all_priorities.filter(s => this.state.indentSearchForm.search_isc_priorities.includes(s.value))}
                                                    placeholder="Select Priorities"
                                                    containerHeight="30px"
                                                    fontSize="93%"
                                                />
                                            </div>
                                        </div>
                                        <div className="row my-3 align-items-center">
                                            <label className="col-sm-2 col-form-label col-form-label-sm ">Item</label>
                                            <div className="col-sm-10">
                                                <InputItemSearch
                                                    placeholder="Search Item"
                                                    isMulti={true}
                                                    changeEvent={(selectedOption) => {
                                                        this.tapSelectChange(selectedOption, 'indentSearchForm', 'search_item_ids');
                                                        this.setState({
                                                            searchedItems: selectedOption ? selectedOption : null
                                                        }, () => { });
                                                    }}
                                                    containerHeight="30px"
                                                    fontSize="93%"
                                                    value={this.state.searchedItems.length > 0 ? this.state.searchedItems.map(a => { a.label = a.display_label; return a; }) : []}
                                                />
                                            </div>

                                        </div>
                                        <div className="row my-3 align-items-center">
                                            <label className="col-sm-2 col-form-label col-form-label-sm  ">Item Tags</label>
                                            <div className="col-sm-10">
                                                <TapSelect
                                                    options={this.state.allItemTags}
                                                    changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'indentSearchForm', 'search_item_tags')}
                                                    value={this.state.allItemTags.filter(u => this.state.indentSearchForm?.search_item_tags?.includes(u.value))}
                                                    isSearchable={true}
                                                    isMulti={true}
                                                    isClearable={true}
                                                    placeholder="Select Item Tags"
                                                    containerHeight="30px"
                                                    fontSize="93%"
                                                />
                                            </div>
                                        </div>
                                        <div className="row my-3 align-items-center">
                                            <label className="col-sm-2 col-form-label col-form-label-sm ">Indent For</label>
                                            <div className="col-sm-10">
                                                <TapSelect
                                                    changeEvent={(selectedOption) => {
                                                        this.tapSelectChange(selectedOption, 'indentSearchForm', 'search_indent_for', () => {
                                                            this.setState({
                                                                searchedAssets: [],
                                                                searchedEmployees: [],
                                                                searchedWorkstations    :   [],
                                                                searchedCustomers   :   [],
                                                                searchedSubAssemblies : [],
                                                                indentSearchForm: {
                                                                    ...this.state.indentSearchForm,
                                                                    search_asset_ids: [],
                                                                    search_employee_ids: [],
                                                                    search_workstation_ids: [],
                                                                    search_customer_ids :   [],
                                                                    search_sub_assembly_ids :   []
                                                                }
                                                            })
                                                        });
                                                    }}
                                                    options={this.state.allIndentOptions}
                                                    isSearchable={true}
                                                    isClearable={true}
                                                    containerHeight="30px"
                                                    fontSize="93%"
                                                    value={this.state.allIndentOptions.find(s => s.value == this.state.indentSearchForm.search_indent_for)}
                                                    placeholder="Select Indent For"
                                                />
                                            </div>

                                        </div>
                                        {this.state.indentSearchForm && this.state.indentSearchForm.search_indent_for ?
                                            <div className="row my-3 align-items-center">
                                                <label className="col-sm-2 col-form-label col-form-label-sm">
                                                    {this.state.indentSearchForm.search_indent_for == "asset" ? "Asset" :
                                                        this.state.indentSearchForm.search_indent_for == "workstation" ? "Workstation" :
                                                            this.state.indentSearchForm.search_indent_for == "employee" ? "Employee" 
                                                            :  this.state.indentSearchForm.search_indent_for == "customer" ? "Customer"  : 
                                                              this.state.indentSearchForm.search_indent_for == "sub_assembly" ? "Sub Assembly"  : 
                                                            null}
                                                    </label>
                                                <div className="col-sm-10">
                                                    {this.state.indentSearchForm.search_indent_for == "asset"
                                                        ? <Ax>
                                                            <InputAssetSearch
                                                                changeEvent={(selectedOption) => {
                                                                    this.tapSelectChange(selectedOption, 'indentSearchForm', 'search_asset_ids');
                                                                    this.setState({ searchedAssets: selectedOption && selectedOption.length > 0 ? selectedOption : [] });
                                                                }}
                                                                placeholder="Search Asset"
                                                                isMulti={true}
                                                                containerHeight="30px"
                                                                fontSize="93%"
                                                                value={this.state.searchedAssets.length > 0 ? this.state.searchedAssets.map(a => { a.label = a.display_label; return a; }) : []}
                                                            />
                                                        </Ax>
                                                        : this.state.indentSearchForm.search_indent_for == "workstation"
                                                            ? <Ax>
                                                                <InputWorkstationSearch
                                                                    placeholder="Please Select Workstation"
                                                                    changeEvent={(selectedOption) => {
                                                                        this.tapSelectChange(selectedOption, 'indentSearchForm', 'search_workstation_ids');
                                                                        this.setState({ searchedWorkstations: selectedOption && selectedOption.length > 0 ? selectedOption : [] });

                                                                    }}
                                                                    menuPlacement="top"
                                                                    isMulti={true}
                                                                    containerHeight="30px"
                                                                    fontSize="93%"
                                                                    value={this.state.searchedWorkstations.length > 0 ? this.state.searchedWorkstations.map(a => { a.label = a.label; return a; }) : []}
                                                                />
                                                                {/* <TapSelect
                                                                    changeEvent={(selectedOption) => {
                                                                        this.tapSelectChange(selectedOption, 'indentSearchForm', 'search_workstation_ids');
                                                                    }}
                                                                    options={this.state.allWorkstations}
                                                                    isSearchable={true}
                                                                    isClearable={true}
                                                                    isMulti={true}
                                                                    containerHeight="30px"
                                                                    fontSize="93%"
                                                                    value={this.state.allWorkstations.filter(m => this.state.indentSearchForm.search_workstation_ids.includes(m.value))}
                                                                    placeholder="Please Select Workstation"
                                                                /> */}

                                                            </Ax>
                                                            : this.state.indentSearchForm.search_indent_for == "employee"
                                                                ? <Ax>

                                                                    <InputEmployeeSearch
                                                                        placeholder="Please Select Employee"
                                                                        changeEvent={(selectedOption) => {
                                                                            this.tapSelectChange(selectedOption, 'indentSearchForm', 'search_employee_ids');
                                                                            this.setState({ searchedEmployees: selectedOption && selectedOption.length > 0 ? selectedOption : [] });
                                                                        }}
                                                                        isMulti={true}
                                                                        containerHeight="30px"
                                                                        fontSize="93%"
                                                                        value={this.state.searchedEmployees.length > 0 ? this.state.searchedEmployees.map(a => { a.label = a.label; return a; }) : []}
                                                                    />
                                                                </Ax> : 
                                                                this.state.indentSearchForm.search_indent_for == "sub_assembly"
                                                                ? <Ax>

                                                                    <InputSubAssemblySearch
                                                                        placeholder="Please Select Sub Assembly"
                                                                        changeEvent={(selectedOption) => {
                                                                            this.tapSelectChange(selectedOption, 'indentSearchForm', 'search_sub_assembly_ids');
                                                                            this.setState({ searchedSubAssemblies: selectedOption && selectedOption.length > 0 ? selectedOption : [] });
                                                                        }}
                                                                        isMulti={true}
                                                                        containerHeight="30px"
                                                                        fontSize="93%"
                                                                        value={this.state.searchedSubAssemblies.length > 0 ? this.state.searchedSubAssemblies.map(a => { a.label = a.label; return a; }) : []}
                                                                    />
                                                                </Ax> : this.state.indentSearchForm.search_indent_for == "customer"
                                                                ? <Ax>

                                                                    <InputCustomerSearch
                                                                        placeholder="Please Select Customer"
                                                                        changeEvent={(selectedOption) => {
                                                                            this.tapSelectChange(selectedOption, 'indentSearchForm', 'search_customer_ids');
                                                                            this.setState({ searchedCustomers: selectedOption && selectedOption.length > 0 ? selectedOption : [] });
                                                                        }}
                                                                        isMulti={true}
                                                                        containerHeight="30px"
                                                                        fontSize="93%"
                                                                        value={this.state.searchedCustomers.length > 0 ? this.state.searchedCustomers.map(a => { a.label = a.label; return a; }) : []}
                                                                    />
                                                                </Ax> : null
                                                    }

                                                </div>
                                            </div> : null}
                                        <div className="row my-3 align-items-center">
                                            <label className="col-sm-2 col-form-label col-form-label-sm  ">Tag Category</label>
                                            <div className="col-sm-10">
                                                <TapSelect
                                                    isSearchable={true}
                                                    isClearable={true}
                                                    placeholder="All"
                                                    containerHeight="30px"
                                                    fontSize="93%"
                                                    options={this.state.userFilters}
                                                    value={this.state.userFilters.find(r => r.value === this.state.indentSearchForm.tagged_user_filter)}
                                                    changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'indentSearchForm', 'tagged_user_filter')}
                                                />
                                            </div>
                                        </div>
                                        <div className="row my-3 align-items-center">
                                            <label className="col-sm-2 col-form-label col-form-label-sm  ">Tagged User</label>
                                            <div className="col-sm-10">
                                                <TapSelect
                                                    isSearchable={true}
                                                    isClearable={true}
                                                    isMulti={true}
                                                    placeholder="Tagged User"
                                                    containerHeight="30px"
                                                    fontSize="93%"
                                                    options={this.state.allUsers}
                                                    value={this.state.allUsers.filter(s => this.state.indentSearchForm.tagged_user_ids.includes(s.value))}
                                                    changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'indentSearchForm', 'tagged_user_ids')}
                                                />
                                            </div>
                                        </div>
                                        <div className="row my-3 align-items-center">
                                            <label className="col-sm-2 col-form-label col-form-label-sm">Ticket</label>
                                            <div className="col-sm-10">
                                                <InputTicketSearch
                                                    containerHeight="30px"
                                                    fontSize="93%"
                                                    changeEvent={(selectedOption) => {
                                                        this.tapSelectChange(selectedOption, 'indentSearchForm', 'search_ticket_ids');
                                                        this.setState({ searchedTickets: selectedOption && selectedOption.length > 0 ? selectedOption : [] });
                                                    }}
                                                    isMulti={true}
                                                    menuPlacement="top"
                                                    value={this.state.searchedTickets.length > 0 ? this.state.searchedTickets.map(a => { a.label = a.display_label; return a; }) : []}
                                                    search_exclude_ticket_status={[0,26, 10]}
                                                />
                                            </div>
                                        </div>

                                        <div className="row my-3 align-items-center">
                                            <label className="col-sm-2 col-form-label col-form-label-sm">Project</label>
                                            <div className="col-sm-10">
                                                <InputProjectSearch
                                                    changeEvent={(selectedOption) => {
                                                        this.tapSelectChange(selectedOption, 'indentSearchForm', 'search_project_ids');
                                                        this.setState({ searchedProjects: selectedOption && selectedOption.length > 0 ? selectedOption : [] });
                                                    }}
                                                    placeholder="Search Project"
                                                    isMulti={true}
                                                    containerHeight="30px"
                                                    fontSize="93%"
                                                    value={this.state.searchedProjects.length > 0 ? this.state.searchedProjects.map(a => { a.label = a.display_label; return a; }) : []}
                                                />
                                                {/* <input
                                                    type="text"
                                                    name="search_project_id"
                                                    className="form-control form-control-sm"
                                                    placeholder="Project"
                                                    autoComplete="off"
                                                    value={this.state.indentSearchForm.search_project_id}
                                                    onChange={(e) => this.formInputHandler(e, "indentSearchForm")}
                                                /> */}
                                            </div>
                                        </div>
                                        <div className="row my-3 align-items-center">
                                            <label className="col-sm-2 col-form-label col-form-label-sm  ">Voucher Ageing</label>
                                            <div className="col-sm-10">
                                                <input
                                                    name="search_voucher_aging"
                                                    type="text"
                                                    value={this.state.indentSearchForm.search_voucher_aging}
                                                    className="form-control"
                                                    autoComplete="off"
                                                    onChange={(e) => this.formInputHandler(e, "indentSearchForm")}
                                                    placeholder="Example. 0-5 for a range or 4 for Voucher Ageing"
                                                    style={{ height: "30px", fontSize: "93%" }}
                                                />
                                            </div>

                                        </div>
                                        <div className="row my-3 align-items-center">

                                            <label className="col-sm-2 col-form-label col-form-label-sm  ">Approval Ageing</label>
                                            <div className="col-sm-10">
                                                <input
                                                    name="search_approved_aging"
                                                    type="text"
                                                    value={this.state.indentSearchForm.search_approved_aging}
                                                    className="form-control"
                                                    autoComplete="off"
                                                    onChange={(e) => this.formInputHandler(e, "indentSearchForm")}
                                                    placeholder="Example. 0-5 for a range or 4 for Approval Ageing"
                                                    style={{ height: "30px", fontSize: "93%" }}
                                                />
                                            </div>


                                        </div>
                                        <div className="row my-3 align-items-center">
                                            <label className="col-sm-2 col-form-label col-form-label-sm ">Transaction Period</label>
                                            <div className="col-sm-10">
                                                <PeriodSelectionWithCustom
                                                    periods={this.state.all_periods ? this.state.all_periods : []}
                                                    value={this.state.indentSearchForm.date_range}
                                                    startDate={this.state.indentSearchForm.date_range_start}
                                                    endDate={this.state.indentSearchForm.date_range_end}
                                                    onSelectPeriod={(period, startDate, endDate) => {
                                                        this.setState({
                                                            indentSearchForm
                                                                : {
                                                                ...this.state.indentSearchForm,
                                                                date_range: period,
                                                                date_range_start: startDate ? startDate : null,
                                                                date_range_end: endDate ? endDate : null
                                                            }
                                                        });
                                                    }}
                                                    className="form-control-sm"
                                                    containerHeight="30px"
                                                    fontSize="93%"
                                                />
                                            </div>
                                        </div>

                                    </Ax>}
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={this.indentClear}>Close</button>
                                <button type="submit" className="btn btn-primary">Search</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
   }

   cancelledItemModalJsx               =        ()             =>        {
      
    return (
        <div className="modal fade" id="cancelIndentModal" tabIndex="-1">
            <div className="modal-dialog modal-xl">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="searchAssetModalLabel">Cancel Item for : {this.state.indentTransId}</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => { this.setState({ cancelledItemList: [] }) }}></button>
                    </div>
                    <form onSubmit={this.submitCancelItemForm}>
                        <div className="modal-body">
                            {this.state.cancel_item_loading ? <Loader />
                                : <Ax>
                                    <table className="table table-bordered table-responsive bg-white ">
                                        <thead className="table-secondary">
                                            <tr className="text-end">
                                                <th scope="col" style={{ width: "5%" }} className="text-center">S.No</th>
                                                <th scope="col" style={{ width: "28%" }} className="text-start">Item Details</th>
                                                <th scope="col" className="text-center" style={{ width: "8%" }}>Indent Qty</th>
                                                <th scope="col" className="text-end" style={{ width: "8%" }}>Fullfilled</th>
                                                <th scope="col" className="text-end" style={{ width: "8%" }}>Pur. Req</th>
                                                <th scope="col" className="text-end" style={{ width: "8%" }}>PO</th>
                                                <th scope="col" className="text-end" style={{ width: "8%" }}>Purchase</th>
                                                <th scope="col" className="text-end" style={{ width: "8%" }}>In Transit </th>
                                                <th scope="col" className="text-end" style={{ width: "8%" }}>Cancelled  </th>
                                                <th scope="col" className="text-end" style={{ width: "8%" }}>Pending </th>
                                                <th scope="col" style={{ width: "9%" }}>New Cancelled </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.cancelledItemList.map((i, k) => {
                                                return <tr className="text-end" key={k}>
                                                    <td className="text-center align-middle">{k + 1}</td>

                                                    <td className='text-start'>{i.itemData ? <div><span className="fw-bold">{i.itemData.name}</span><br />
                                                        <div className="form-text"><b>Code: </b>{i.itemData.item_code}</div>
                                                        <div className="form-text"><b>Mfr: </b>{i.itemData?.manufacturer?.name ?? '-'} (MPN : {i.itemData?.manufacturer_part_no ?? "-"} )</div>
                                                        <div className="form-text"> {
                                                            i.itemData?.tags?.length > 0
                                                                ? (i.itemData?.tags.map((item, k) => <span key={k} className="badge bg-secondary">{item.name}</span>))
                                                                : '-'
                                                        }</div>
                                                        <div className="form-text"><b>Remark: </b>{i.remark ?? "-"}</div>
                                                    </div>
                                                        : null}</td>
                                                    <td>{i.indent_qty ? i.indent_qty : 0}</td>
                                                    <td>{i.fullfilled_qty ? i.fullfilled_qty : 0}</td>
                                                    <td>{i.req_qty ? i.req_qty : 0}</td>
                                                    <td>{i.po_qty ? i.po_qty : 0}</td>
                                                    <td>{i.purchase_qty ? i.purchase_qty : 0}</td>
                                                    <td>{i.transit_qty ? i.transit_qty : 0}</td>
                                                    <td>{i.cancelled_qty ? i.cancelled_qty : 0}</td>
                                                    <td>{i.pending_qty ? i.pending_qty : 0}</td>
                                                    <td className="text-end"> 
                                                        <TapInputNumber
                                                            name="new_cancelled_qty"
                                                            value={this.state.cancelledItemList[k]?.new_cancelled_qty}
                                                            onChange={(newValue) => {
                                                                const updatedRows = [...this.state.cancelledItemList];
                                                                updatedRows[k].new_cancelled_qty = newValue; // Update the quantity in the corresponding row
                                                                this.setState({ cancelledItemList: updatedRows });
                                                            }}
                                                            placeholder="Cancelled Qty"
                                                            required={true}
                                                            max={i.pending_qty}
                                                        />
                                                        
                                                    </td>




                                                </tr>
                                            })}
                                        </tbody>
                                    </table>
                                    <div className="row align-items-center ">
                                        <div className="col-sm-6">
                                            <label htmlFor="notes" className="form-label">Notes</label>
                                            <div> <textarea
                                                name="notes"
                                                value={this.state.cancelledItemForm.notes}
                                                onChange={(e) => this.formInputHandler(e, 'cancelledItemForm')}
                                                className="form-control"
                                                style={{ height: "100px" }}
                                            /></div>

                                        </div>
                                    </div>
                                </Ax>}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" disabled={this.state.cancelItemFormSubmitting}
                                onClick={() => { this.setState({ cancelledItemList: [] }) }}>Close  {this.state.cancelItemFormSubmitting ? (<tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin" />) : ''}</button>
                            <button type="submit" className="btn btn-primary" disabled={this.state.cancelItemFormSubmitting}>Save  {this.state.cancelItemFormSubmitting ? (<tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin" />) : ''}</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        );
    }

    viewInterchangeableItemJsx                            =   ()  =>  {
       
        let data = this.state.interchangeItemData ? this.state.interchangeItemData : null;
        let max_qty = data && data.pending_qty ? data.pending_qty : 0;

        return (
            <div className="modal fade" id="interchangebleItemModal" tabIndex="-1">
                <div className="modal-dialog modal-lg modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="interchangebleItemModal">Interchange Item  </h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        {data && <div className='p-1 bg-light border-bottom'>
                            <table className='table table-sm mb-0 table-borderless text-sm'>
                                <tbody>
                                    <tr>
                                        <td>Transaction ID </td>
                                        <th>{this.state.indentTransId}</th>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "26%" }}>Item Name     </td>
                                        <th>{data.itemData && data.itemData.name ? data.itemData.name : ""} </th>
                                    </tr>
                                    <tr>
                                        <td>Item Code </td>
                                        <th>{data.itemData && data.itemData.item_code ? data.itemData.item_code : "-"}</th>
                                    </tr>
                                  
                                    <tr>
                                        <td>Pending Qty </td>
                                        <th>{data && data.pending_qty ? data.pending_qty : '0'}</th>
                                    </tr>
                                   
                                </tbody>
                            </table>
                        </div>
                        }

                        <div className="modal-body">
                            <form className="bg-white" onSubmit={this.submitSelectedInterchangeItem} id="interchangeItemForm" method="post" encType="multipart/form-data">
                                <table className="table table-hover table-bordered table-responsive bg-white my-3 table-sm">
                                    <thead className="table-secondary">
                                        <tr className="text-center">
                                            <th style={{ "width": '7%' }}>
                                            <input type='checkbox' onChange={this.checkAllInterchangeList} id="all_check_interchange" />
                                            </th>
                                            <th className="text-start">Item Details</th>
                                            
                                            <th style={{ width: "13%" }} className="text-end">Qty</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.interchangeable_loading
                                            ? (<tr><td colSpan="6"><Loader /></td></tr>)
                                            : (this.state.interchangeableItemList && this.state.interchangeableItemList.length > 0
                                                ? (this.state.interchangeableItemList.map((item, k) => {
                                                    return (<tr key={k} className="text-center">
                                                        <td>
                                                            <input type='checkbox'
                                                                className="interchange_id_checkbox"
                                                                name="interchangebleItem"
                                                                value={item.id}
                                                                data-qty={item?.new_qty}
                                                            />
                                                        </td>
                                                        <td className="text-start"><Ax>
                                                            <b>{item.name} </b> <br />
                                                            <small>Code : <b> {item.item_code} </b></small> <br />
                                                            <small>Mfr : <b> {item.manufacturer?.name ?? '-'} </b>  (MPN : <b> {item.manufacturer_part_no ?? '-'}</b>)</small>
                                                        </Ax></td>
                                                        <td>
                                                            <input
                                                                className='form-control form-control-sm text-end'
                                                                placeholder='Quantity'
                                                                name="new_qty"
                                                                type="number"
                                                                value={item.new_qty}
                                                                onChange={(e) => {
                                                                    this.state.interchangeableItemList[k] = { ...item, new_qty: e.target.value };
                                                                    this.dynamicInputHandlerByKeyNameVal(e.target.value, 'new_qty', k, 'interchangeableItemList')
                                                                }}
                                                                max={max_qty}
                                                                autoComplete="off"
                                                                step=".01" />
                                                        </td>
                                                        

                                                    </tr>);
                                                }))
                                                : (<tr><td colSpan="6" className="text-center">No Records</td></tr>)
                                            )
                                        }
                                    </tbody>
                                </table>
                                <div className="row align-items-center ">
                                    <div className="col-sm-6">
                                        <label htmlFor="notes" className="form-label">Notes</label>
                                        <div> <textarea
                                            name="notes"
                                            value={this.state.interchangeItemForm.notes}
                                            onChange={(e) => this.formInputHandler(e, 'interchangeItemForm')}
                                            className="form-control"
                                            autoComplete='off'
                                            style={{ height: "100px" }}
                                        /></div>

                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="modal-footer">
                            <button type="submit" disabled={this.state.saveInterchangeableItemForm} className="btn btn-primary" form="interchangeItemForm">Submit {this.state.saveInterchangeableItemForm ? (<tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin" />) : ''}</button>
                        </div>

                    </div>
                </div>
            </div>
        );
    }


    updateRemarkModalInit = (item) => {
        this.setState({ remarkItem : item }, () => {
            this.updateRemarkModal.show();
        });
    }

    handleRemarkForm  =   (e) => {
        e.preventDefault();

        let {item_id : indent_item_id, transaction_id, remark } =  this.state.remarkItem;
        let itemData        =   this.state.indentDetail.items.find(i => i.item_id == indent_item_id);
        if(!itemData) {
            toast.error('Item not found', { position: toast.POSITION.TOP_RIGHT });
        } else if(remark == itemData.remark) {
            this.updateRemarkModal.hide();
        } else {
            this.setState({remarkSubmitting: true});
            HttpAPICall.withAthorization('PUT', this.itemRemarkEditUrl, this.props.access_token, {}, {indent_item_id ,transaction_id, remark}, (response) => {
                this.getIndentDetail(transaction_id);
                toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
            }).then(() =>  {
                this.updateRemarkModal.hide();
                this.setState({remarkSubmitting: false});
            });
        }

        
    }

    updateRemarkModalJsx = () => {
        
        const indentDetail          =   this.state.indentDetail;
        let indentItem              =   this.state.remarkItem;
        return (
            <div className="modal fade" id="indentRemarkForm" tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="searchItemModalLabel">Update Remarks</h5>
                            <button
                                disabled={this.state.remarkSubmitting}
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        {this.state.view_loading ? <Loader /> : indentItem && <div className='p-1 bg-light border-bottom'>
                            <table className='table table-sm mb-0 table-borderless text-sm'>
                                <tbody>
                                    <tr>
                                        <td style={{ width: "30%" }}>Item Indent ID </td>
                                        <th>{indentDetail.transaction_id}</th>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "30%" }}>Item Name </td>
                                        <th>{indentItem && indentItem.itemData ? indentItem.itemData.name : "-"}</th>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "30%" }}>Item Code </td>
                                        <th>{indentItem && indentItem.itemData ? indentItem.itemData.item_code : "-"}</th>
                                    </tr>
                                </tbody>
                            </table>
                        </div> }
                        <div className="modal-body ">
                            <form className="" id="indentRemark" onSubmit={this.handleRemarkForm} >
                                <div className="row align-items-center ">
                                    <div className="col-sm-12">
                                        <label htmlFor="notes" className="form-label">Remarks</label>
                                        <textarea
                                            name="Remarks"
                                            value={indentItem && indentItem.remark ? indentItem.remark : ''}
                                            onChange={e => {
                                                this.setState({ remarkItem: {...this.state.remarkItem, remark : e.target.value} })
                                            }}
                                            className="form-control"
                                            autoComplete='off'
                                            style={{ height: "80px" }}
                                        />
                                    </div>
                                </div>
                            </form>
                            <div className="modal-footer">
                                <button disabled={this.state.remarkSubmitting} type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                <button disabled={this.state.remarkSubmitting} type="submit" form='indentRemark' className="btn btn-primary">save</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }



    render                              =   ()  =>  {
        return (<ApplicationLayout>
        <Helmet><title>Warehouse Indent Listing</title></Helmet>
            {this.storeIndentJsx()}
            {this.indentSearchModalJsx()}
             
        </ApplicationLayout>);
    }

}


const mapStateToProps = state => {
    return {
        access_token            :   state.auth.access_token,
        isc_configuration       :   state.app && state.app.isc_configuration ? state.app.isc_configuration : null,
        all_periods             :   state.app && state.app.all_periods ? state.app.all_periods : [],
        all_warehouses          :   state.app && state.app.warehouses ? state.app.warehouses : [],
        permissions             :   state.app.acl_info && state.app.acl_info.permissions && state.app.acl_info.permissions.length > 0 ? state.app.acl_info.permissions : [],
        settings                :   state.app.setting
    };
};

export default connect(mapStateToProps)(WarehouseIndentList);